import React from 'react'
import cx from 'classnames'

export default Heading = ({children, className, size, element: El}) ->
  Elem = El ? "h1"
  React.createElement(Elem, { \
    "className": (cx "TeamReport__h", className, size and "TeamReport__h_#{size}")
  }, (children))
